<template>
  <div class="c-emptyFavorite">
    <div class="m-emptyState m-emptyState--large">
      <img class="m-emptyState_image" :src="require('icon/empty-state/circle-search-love.svg')" alt="poste indicador" title="endereco não encontrado">
      <p class="m-emptyState_title">Ops, nenhum fornecedor foi favoritado nesta especialidade ou região</p>
      <p class="m-emptyState_paragraph">Para favoritar fornecedores, volte para a lista e clique nos corações ❤️</p>
    </div>

    <div class="c-emptyFavorite_grid">
      <button class="c-emptyFavorite_buttonLight" @click="filterAll()">Voltar para lista completa</button>
      <a class="c-emptyFavorite_buttonMain" :href="userAccount.favorite">Gerenciar fornecedores favoritos</a>
    </div>
  </div>
</template>

<script>
import { userAccount } from 'routes'
import { mapActions, mapState } from 'vuex'
import { parse as parseUrl } from 'url'
import { categoryDirectory } from 'routes'

const initialState = () => ({
  userAccount
})

export default {
  props: {
    modifier: String
  },

  data() {
    return initialState()
  },

  computed: {
    ...mapState({
      slug: state => state.categoryDirectory.info.slug,
    }),

    defaultUrl() {
      const { query } = parseUrl(location.href)
      const { serviceType, region } = this.slug
      const pathname = categoryDirectory.serviceType(serviceType, region)

      return query
        ? `${pathname}?${query}`
        : `${pathname}`
    },
  },

  methods: {
    ...mapActions({
      updateCategorySelected: 'categoryDirectory/updateCategorySelected',
      getCategoryInfo: 'categoryDirectory/getCategoryInfo',
    }),

    async filterAll() {
      this.updateCategorySelected({ favorite: false })

      try {
        const { data } = await this.getCategoryInfo()

        history.replaceState(data, '', this.defaultUrl)
      } catch (err) {
        throw err
      }
    },
  }
}
</script>

<style lang="scss">
@import "~css/_references";
@import "~css/Modules/box";
@import "~css/Modules/button";

.c-emptyFavorite {
  @extend .m-box;
  @extend .m-box--large;

  &_grid {
    display: flex;
    flex-flow: row wrap;
    margin-top: $v-gap-md;
    justify-content: center;
  }

  &_buttonLight {
    @extend .m-button;
    @extend .m-button--secondaryLight;
    @extend .m-button--small;
    max-width: 270px;
    margin: $v-gap-xxs;
    font-weight: normal;
    font-size: 14px;
  }

  &_buttonMain {
    @extend .m-button;
    @extend .m-button--small;
    max-width: 270px;
    margin: $v-gap-xxs;
    font-weight: normal;
    font-size: 14px;
  }
}
</style>
